import { useMemo } from "react";
import AddPageSubMenu from "src/components/layouts/AddPageSubMenu";
import { createTrialSettingsSubMenu } from "src/routing/navigation";

const TrialSettingsSubMenu: React.FC = () => {
    const subMenu = useMemo(() => {
        return createTrialSettingsSubMenu();
    }, []);

    if (!subMenu) {
        return null;
    }

    return <AddPageSubMenu subMenu={subMenu} />;
};

export default TrialSettingsSubMenu;
